import {useEffect, useRef, useState} from "react";
import {getBasicAuthHeader} from "../../utils/auth";
import Credentials from "./Credentials";
import {Toast} from "primereact/toast";
import AdminInternalPanel from "./AdminInternalPanel";

function AdminPanel() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

    console.log("Backend URL:", process.env.REACT_APP_BACKEND_URL);

    useEffect(() => {
        if (isLoggedIn) {
            return;
        }

        async function testSessionId() {
            setIsLoading(true);
            try {
                const response = await fetch(
                    `/api/auth/session`,
                    {
                        method: "GET",
                        credentials: "include",
                    },
                );

                if (response.ok) {
                    setIsLoggedIn(true);
                }
            } finally {
                setIsLoading(false);
            }
        }

        testSessionId();
    }, [isLoggedIn]);

    const toast = useRef<Toast>(null);

    const showLoginSuccess = () => {
        toast.current!.show({
            severity: "success",
            summary: "Eingeloggt",
            detail: "Zugang gewährt!",
        });
    };
    const showLoginError = () => {
        toast.current!.show({
            severity: "error",
            summary: "Falsch",
            detail: "Weiche du Schuft!",
            life: 3000,
        });
    };

    function onLoginClick(username: string, password: string): void {
        setIsLoading(true);

        async function fetchLogin() {
            const authorizationHeader = getBasicAuthHeader(username, password);

            try {
                const response = await fetch(
                    `/api/auth/login`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: authorizationHeader,
                        },
                        credentials: "include",
                    },
                );

                if (response.ok) {
                    setIsLoggedIn(true);
                    showLoginSuccess();
                } else {
                    showLoginError();
                }
            } catch {
                showLoginError();
                return;
            } finally {
                setIsLoading(false);
            }
        }

        fetchLogin();
    }

    async function onLogout() {
        try {
            await fetch(`/api/auth/logout`, {
                method: "POST",
                credentials: "include",
            });
        } finally {
            setIsLoggedIn(false);
        }
    }

    return (
        <div
            style={{
                maxWidth: "800px",
                margin: "0 auto",
                padding: "1rem",
                boxSizing: "border-box",
            }}
        >
            <Toast ref={toast}/>
            {!isLoggedIn && (
                <Credentials isLoading={isLoading} onLoginClick={onLoginClick}/>
            )}
            {isLoggedIn && (
                <AdminInternalPanel isLoggedIn={isLoggedIn} onLogout={onLogout}/>
            )}
        </div>
    );
}

export default AdminPanel;
